import {createStopSaleFail,createStopSalePending,createStopSaleSuccess,getStopSalePending,
        getStopSaleSuccess,getStopSaleFail,deleteStopSaleFail,deleteStopSalePending,deleteStopSaleSuccess,
        getSStopSaleFail,getSStopSalePending,getSStopSaleSuccess, modifyStopSaleFail,modifyStopSalePending,modifyStopSaleSuccess } from "./stopsaleSlice";
import { fetchAllStopSale, fetchSingleStopSale, stopsaleCreation, stopsaleDelete,stopsaleModify} from "../../../api/userApi";
import Swal from "sweetalert2";
export const getAllStopSale = () => async (dispatch) => {
    try {
        //call the api
        dispatch(getStopSalePending());
        const result = await fetchAllStopSale();
        const myJSON = JSON.stringify(result);
        const myObj  =  JSON.parse(myJSON);
        const stopsaledetails  = JSON.parse(JSON.stringify(myObj.stopsale));
        const stopsaledetails1 = JSON.parse(JSON.stringify(stopsaledetails));

        if (stopsaledetails) {
        
            return dispatch(getStopSaleSuccess(stopsaledetails));
        }
        dispatch(getStopSaleFail("Stop Sale is not found"));


    } catch (error) {
        const err = JSON.parse(JSON.stringify(error));
        
         dispatch(getStopSaleFail(err.msg));

    }
}

// export const getAllProductImage = () => async (dispatch) => {
//     try {
//         //call the api
//         dispatch(getProductImagePending());
//         const result = await fetchAllProductImage();
//         console.log("prodddssssd",result)
//         //const userData=JSON.parse(result);
//         const myJSON = JSON.stringify(result);

//        // console.log('allProductData ' + myJSON);
//         //console.log('alluserData 1  '+myJSON.user);
//         const myObj = JSON.parse(myJSON);
//         const productdetails = JSON.parse(JSON.stringify(myObj.product));
//         const productdetails1 = JSON.parse(JSON.stringify(productdetails));
//       // console.log('Productdetails ' + productdetails);
//        //console.log( productdetails);
//         if (productdetails) {
        
//             return dispatch(getProductImageSuccess(productdetails));
//         }
//         dispatch(getProductImageFail("Product image is not found"));


//     } catch (error) {
//        //console.log(error.msg);
//         const err = JSON.parse(JSON.stringify(error));
//         // console.log(err.message);
//          //console.log(JSON.parse(JSON.stringify(error)));
//          dispatch(getProductFail(err.msg));

//     }
// }

export const stopsaleDeletion = (frmDt) => async(dispatch) => {

    try {
        dispatch(deleteStopSalePending());
        const result = await stopsaleDelete(frmDt);
        result.status ==="success" 
        ? dispatch(deleteStopSaleSuccess("Stop Sale deleted"))
        : dispatch(deleteStopSaleFail(result.message));
        
    } catch (error) {
       const err = JSON.parse(JSON.stringify(error.response.data.error));
  
        dispatch(deleteStopSaleFail(err.msg));
    }
    
}


// export const productImageDeletion = (frmDt) => async(dispatch) => {

//     try {
//         dispatch(deleteProductImagePending());
//         const result = await productImageDelete(frmDt);
//        // console.log("userCreation "+result);
//       // console.log("try block");
//        //console.log(result.status);
//         result.status ==="success" 
//         ? dispatch(deleteProductImageSuccess("Product Image deleted"))
//         : dispatch(deleteProductImageFail(result.message));
        
//     } catch (error) {
//        // console.log("catch block");
//        const err = JSON.parse(JSON.stringify(error.response.data.error));
//        // console.log(err.message);
//         //console.log(JSON.parse(JSON.stringify(error)));
//         dispatch(deleteProductImageFail(err.msg));
//     }
    
// }

export const newStopSaleCreation = (frmDt) => async (dispatch) => {



  try {
    dispatch(createStopSalePending());
    const result = await stopsaleCreation(frmDt);

    result.status === "success"
      ? dispatch(createStopSaleSuccess(result.result))
      : dispatch(createStopSaleFail(result.message));

    Swal.fire({
      title: 'Success!',
      text: 'Stop Sale Added Successfully',
      icon: 'success',
      confirmButtonText: 'Okay'
    })

  } catch (error) {
    console.log(error);
    const err = JSON.parse(JSON.stringify(error.response.data.error));
    console.log(err);
    Swal.fire({
      title: 'Error',
      html: err.msg,
      icon: 'warning',
      confirmButtonText: 'Okay',
      style: {
        fontSize: '4px', // Adjust the font size as per your preference
        /* Add any other custom styles you want to apply */
      },
    })
    // Swal.fire(err.msg,err.value,'error')


    const row = err.map((er, i) => {
      if (i === er.length - 1) {
        return er.param + ' ' + er.msg + '. ';
      }
      return er.param + ' ' + er.msg + '\n ';
    });

    dispatch(createStopSaleFail(row));


  }

}

export const getSingleStopSale = (id) => async (dispatch) => {
    
     try {
     //call the api
    dispatch(getSStopSalePending());
    const result = await fetchSingleStopSale(id);
    console.log("sjjjjjjjz",result.excursionstopsales[0])

    if(result.excursionstopsales){
        return dispatch(getSStopSaleSuccess(result.excursionstopsales[0]));
    }
    dispatch(getSStopSaleFail("Stop Sale is not found"));
 
   
 } catch (error) {
    const err = JSON.parse(JSON.stringify(error.response.data.error));
   
    dispatch(getSStopSaleFail(err.msg));
 
 }
    
 
 }



// export const getSingleProductImage = (id) => async (dispatch) => {
    
 
//     console.log('serviceeee id : '+id);
//        try {
//         //call the api
//        dispatch(getSProductImagePending());
//        const result = await fetchSingleProductImage(id);
//        console.log("resttttt",result)

//        const myJSON = JSON.stringify(result);

//         const myObj = JSON.parse(myJSON);
//         const productdetails = JSON.parse(JSON.stringify(myObj.product));

//        if(productdetails){
  
//            return dispatch(getSProductImageSuccess(productdetails));
//        }
//        dispatch(getSProductImageFail("Product Image is not found"));
    
      
//     } catch (error) {

//        const err = JSON.parse(JSON.stringify(error.response.data.error));

//        console.log(err.msg);
//        dispatch(getSProductFail(err.msg));
    
//     }
       
    
//     }
   




export const stopsaleModification = (frmDt) => async (dispatch) => {
   
    try {
        dispatch(modifyStopSalePending());
        const result = await stopsaleModify(frmDt);
        console.log("result",result)
        result.status === "success"
            ? dispatch(modifyStopSaleSuccess(result.message))
            : dispatch(modifyStopSaleFail(result.message));

            Swal.fire({
              title: 'Success!',
              text: 'Stop Sale Details Updated Successfully',
              icon: 'success',
              confirmButtonText: 'Okay'
            })

    } catch (error) {
       
  
        const err = JSON.parse(JSON.stringify(error.response.data.error));
        Swal.fire({
            title: 'Failed!',
            text: err.msg,
            icon: 'error',
            confirmButtonText: 'Okay'
          })
     
        dispatch(modifyStopSaleFail(err.msg));
    }

}


// export const productImageModification = (frmDt) => async (dispatch) => {
   
//     try {
//         dispatch(modifyProductImagePending());
//         const result = await productImageModify(frmDt);
//         console.log("result",result)
//         result.status === "success"
//             ? dispatch(modifyProductImageSuccess(result.message))
//             : dispatch(modifyProductImageFail(result.message));

//           //  console.log("userRoleModify "+result);
//             // console.log("try block");
//             //console.log(result.status);
//             //console.log('actions '+result.message);

//     } catch (error) {
//         // console.log("catch block");
//         // console.log("cattttttttt")
//         // Swal.fire({
//         //     title: 'Error!',
//         //     text: 'This Product exist with another record',
//         //     icon: 'error',
//         //     confirmButtonText: 'Close'
//         //   })
  
//         const err = JSON.parse(JSON.stringify(error.response.data.error));
     
//         dispatch(modifyProductImageFail(err.msg));
//     }

// }


// export const resetProductCreatiion = () => async (dispatch) => {
//     try {

//         dispatch(reset());
//     }
//     catch{


//     }
// }


// export const imageuploadProcess = (msg) => async (dispatch) => {
//     try {

//         dispatch(imageUploadSuccess(msg));
//     }
//     catch{


//     }
// }


// export const imageUploadFailureProcess = (msg) => async (dispatch) => {
//     try {

//         dispatch(imageUploadFailure(msg));
//     }
//     catch{


//     }
// }
